import React from 'react'

export const Home = () => {
  // TODO: Add more informative messaging here
  return (
    <div>This is an empty home page</div>
  )
}